import { CreateFeedbackPayload, Feedback } from "../types/feedback.definition";
import { createFeedback, getManagerFeedbacks } from "../webclients/feedback.client";

export const feedbackApi = {
  createFeedback: async (data: CreateFeedbackPayload): Promise<Feedback> => {
    const response = await createFeedback(data);
    return response.data;
  },
  getManagerFeedbacks: async (managerId: number): Promise<Feedback[]> => {
    const response = await getManagerFeedbacks(managerId);
    return response.data;
  },
};

export default feedbackApi;

